import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectTranslations } from '../App/slice/selectors';
import { IHolidayContact } from '../HolidayCheckout/types';
import { usePhoneFormat } from '../HolidayCheckout/hooks/usePhoneFormat';

interface IContactInformationProps {
  dataContact: IHolidayContact;
}
const ContactInformation: React.FC<IContactInformationProps> = props => {
  const { dataContact } = props;
  const translations = useSelector(selectTranslations);
  const { formatPhone } = usePhoneFormat();
  return (
    <InfoTable>
      <InfoRow>
        <InfoLabel>{translations?.['b2b.form.name']}</InfoLabel>
        <InfoValue>{dataContact?.fullName || 'N/A'}</InfoValue>
      </InfoRow>

      <InfoRow>
        <InfoLabel>{translations?.['b2b.txt.contactEmail']}</InfoLabel>
        <InfoValue>{dataContact?.email || 'N/A'}</InfoValue>
      </InfoRow>
      <InfoRow>
        <InfoLabel>{translations?.['b2b.form.phone']}</InfoLabel>
        <InfoValue>
          {dataContact?.phone ? formatPhone(dataContact.phone) : 'N/A'}
        </InfoValue>
      </InfoRow>
    </InfoTable>
  );
};
export default ContactInformation;
const InfoTable = styled.div`
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
`;
const InfoRow = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  &:last-child {
    border-bottom: none;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 12px 16px;
  }
`;
const InfoLabel = styled.div`
  width: 220px;
  padding: 12px 16px;
  background: #f2f2f2;
  font-weight: 500;
  font-size: 14px;
  color: #333;
  @media (max-width: 768px) {
    width: 100%;
    background: transparent;
    padding: 0;
    margin-bottom: 4px;
    font-size: 13px;
    color: #888;
  }
`;
const InfoValue = styled.div`
  flex: 1;
  padding: 12px 16px;
  font-size: 14px;
  color: #555;
  word-break: break-word;
  @media (max-width: 768px) {
    padding: 0;
    font-size: 15px;
    color: #222;
  }
`;
